import {
  Autocomplete,
  Alert,
  Button,
  Chip,
  Grid,
  Paper,
  SnackbarContent,
  TextField,
  Typography,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useEffect, useRef, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import { useLocation, useNavigate } from "react-router-dom";
import { DesignTemplatesEndPointLogic } from "../../../../../logic/AssetManagement/Design/Templates/DesignTemplatesEndPointLogic";
import {
  selectUserToken,
  setIsLoading,
} from "../../../../../features/userSlice";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { html as beautifyHtml, css as beautifyCss } from "js-beautify";
import "ace-builds/src-noconflict/ext-searchbox";
interface WidgetStructure {
  shared_uid: string;
  name: string;
  widget_meta: string;
}

const EditTemplate = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const [, setDesignTemplatesData] = useState([]) as any;
  const [singlePageContent, setSinglePageContent] = useState([]) as any;
  const [error, setError] = useState(""); // State for error message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [labelsContent, setLabelsContent] = useState<any[]>([]);
  const [/* errorAccToPageStatus, */ setErrorAccToPageStatus] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState<any>([]); // State for selected labels
  const [dialogOpen, setDialogOpen] = useState(false); // State for dialog visibility
  const [templateName, setTemplateName] = useState(""); // State for template name
  const [widgetStructure, setWidgetStructure] = useState<WidgetStructure[]>([]); //  State for widget structure
  const [additionalSettings, setAdditionalSettings] = useState(""); // State for additional settings
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  // State for error message visibility
  const [selectedWidgetStructure, setSelectedWidgetStructure] = useState(""); // State for selected widget structure
  const [html, setHtml] = useState(""); // State for HTML
  const [css, setCss] = useState("");
  // State for CSS
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [searchParams] = useSearchParams();
  const [htmlFocus, setHtmlFocus] = useState(false);
  const [cssFocus, setCssFocus] = useState(false);
  const selectedTemplateShareuid = searchParams.get("templateSharedUid") as any;
  const websiteSharedUid = searchParams.get("selectedSite") as any;
  const { designTemplatesData, siteOptions } = useSelector(
    (state: any) => state.template
  );
  const location = useLocation();
  const [, setJsonObject] = useState({});
  const htmlEditorRef = useRef<any>(null);

  useEffect(() => {
    const fetchWebsiteStructure = async () => {
      try {
        if (oauthTokenHeader) {
          await DesignTemplatesEndPointLogic.getWidgetStructures(
            oauthTokenHeader,
            setWidgetStructure
          );
        } else {
          throw new Error("Error fetching website structure data");
        }
      } catch (error) {
        console.error(error, "error");
      }
    };
    fetchWebsiteStructure();
  }, [oauthTokenHeader]);

  useEffect(() => {
    const fetchLabels = async () => {
      try {
        if (oauthTokenHeader) {
          await DesignTemplatesEndPointLogic.getLabels(
            oauthTokenHeader,
            setLabelsContent,
            setErrorAccToPageStatus
          );
        } else {
          throw new Error("Error fetching labels data");
        }
      } catch (error) {
        console.error(error, "error");
      }
    };
    fetchLabels();
  }, [oauthTokenHeader, setErrorAccToPageStatus]);
  // const labels = labelsContent.map((item: any) => item?.label);
  const labels = [...new Set(labelsContent.map((item: any) => item?.label))];

  useEffect(() => {
    const fetchSingleTemplate = async () => {
      setLoading(true);
      try {
        await DesignTemplatesEndPointLogic.getSingleDesignTemplate(
          oauthTokenHeader,
          selectedTemplateShareuid,
          setSinglePageContent,
          setError
        );
      } catch (error) {
        console.error(error, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchSingleTemplate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, selectedTemplateShareuid]);

  useEffect(() => {
    if (singlePageContent) {
      setTemplateName(singlePageContent?.name); // Set the template name from the fetched data
      setSelectedWidgetStructure(singlePageContent.component?.shared_uid || ""); // Set the initial value
      setSelectedLabels(singlePageContent.labels || []); // Set the initial labels
      setHtml(singlePageContent.html); // Set the HTML from the fetched data
      setCss(singlePageContent.css); // Set the CSS from the fetched data
      setAdditionalSettings(singlePageContent.additional_info); // Set the additional settings from the fetched data
    }

    if (error) {
      // Keep existing params except 'templateSharedUid'
      const params = new URLSearchParams(location.search);
      params.delete("templateSharedUid");

      navigate(`/operations/templates?${params.toString()}`); // Redirect to view with filtered params
    }
    // eslint-disable-next-line
  }, [singlePageContent, error, navigate]);

  const updateTemplate = async () => {
    const data = {
      name: templateName,
      component: selectedWidgetStructure,
      html: html,
      css: css,
      additional_info: additionalSettings,
      labels: selectedLabels,
    };
    setLoading(true);
    try {
      if (selectedTemplateShareuid) {
        await DesignTemplatesEndPointLogic.editDesignTemplates(
          oauthTokenHeader,
          data,
          selectedTemplateShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to edit template");
      }
      setDialogOpen(true);
      setIsLoading(true);
      await DesignTemplatesEndPointLogic.getDesignTemplates(
        oauthTokenHeader,
        websiteSharedUid,
        setDesignTemplatesData
      );
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const MAX_ADDITIONAL_INFO_LENGTH = 255; // Set this to the maximum length your database allows
  const isValidHTML = (htmlCode: string): boolean => {
    if (!htmlCode) return true; // Empty HTML is considered valid

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlCode, "text/html");

    // Check for parser errors
    const hasParserError = parsedDocument.querySelector("parsererror") !== null;

    // Check if there's at least one element in the body
    const hasElement = Array.from(parsedDocument.body.childNodes).some(
      (node) => node.nodeType === Node.ELEMENT_NODE
    );

    return !hasParserError && hasElement;
  };

  const isValidCSS = (cssCode: string): boolean => {
    if (!cssCode) return true; // Empty CSS is considered valid

    const style = document.createElement("style");
    style.textContent = cssCode;
    document.head.appendChild(style);

    const sheet = style.sheet as CSSStyleSheet;
    let isValid = true;

    // Check if CSS rules were successfully parsed
    const hasRules = sheet && sheet.cssRules.length > 0;

    // For CSS that might not create rules but is still valid, check syntax
    if (!hasRules) {
      const tempElement = document.createElement("div");
      const originalCssText = tempElement.style.cssText;
      tempElement.style.cssText = cssCode;

      // If cssText didn't change and original CSS wasn't empty, it's likely invalid
      const cssDidApply =
        tempElement.style.cssText !== originalCssText || cssCode.trim() === "";
      isValid = cssDidApply;
    }

    // Clean up - remove the style element
    document.head.removeChild(style);
    return isValid;
  };
  const validate = async () => {
    if (!templateName || !selectedWidgetStructure || !html || !css) {
      setSnackbarOpen(true);
      setSnackbarMessage("Please fill all the fields");
      setIsValid(false);
      return false;
    }

    // Check if templateName is at least 8 characters long and contains only letters and numbers
    const templateNameRegex = /^[a-zA-Z0-9-_&*$#!:|,./\\ ]{8,}$/;
    // const templateNameRegex = /^[a-zA-Z0-9]{8,}$/;
    if (!templateNameRegex.test(templateName)) {
      setSnackbarOpen(true);
      setSnackbarMessage(
        "Template name must be at least 8 characters long and contain only letters, numbers, and underscores"
      );
      setIsValid(false);
      return false;
    }

    // Check if the template name is unique
    const isTemplateNameUnique =
      Array.isArray(designTemplatesData) &&
      designTemplatesData?.filter(
        (item: any) =>
          item?.name?.toLowerCase() === templateName?.toLowerCase() &&
          item?.name.toLowerCase() !== singlePageContent?.name?.toLowerCase()
      ).length === 0;
    if (!isTemplateNameUnique) {
      setSnackbarOpen(true);
      setSnackbarMessage("Template name must be unique");
      setIsValid(false);
      return false;
    }
    // Validate Html
    if (!isValidHTML(html)) {
      setSnackbarOpen(true);
      setSnackbarMessage("Invalid HTML Code");
      setErrorMessage(true);
      setIsValid(false);
      return false;
    } else {
      setErrorMessage(false);
    }

    // Validate CSS
    if (!isValidCSS(css)) {
      setSnackbarOpen(true);
      setSnackbarMessage("Invalid CSS Code");
      setErrorMsg(true);
      setIsValid(false);
      return false;
    } else {
      setErrorMsg(false);
    }

    // Check if additionalSettings is a valid JSON
    try {
      if (additionalSettings) {
        const parsedAdditionalInfo = JSON.parse(additionalSettings);
        // Optionally, you can check if it's an object
        if (typeof parsedAdditionalInfo !== "object") {
          throw new Error("Not an object");
        }
      }
    } catch (e) {
      setSnackbarOpen(true);
      setSnackbarMessage("Additional settings must be a valid JSON object");
      setShowErrorMessage(true);
      setIsValid(false);
      return false;
    }

    // Check if additionalSettings exceeds the maximum length
    if (additionalSettings.length > MAX_ADDITIONAL_INFO_LENGTH) {
      setSnackbarOpen(true);
      setSnackbarMessage(
        `Additional settings must not exceed ${MAX_ADDITIONAL_INFO_LENGTH} characters`
      );
      setShowErrorMessage(true);
      setIsValid(false);
      return false;
    }

    setIsValid(true); // Validation passed
    return true; // Validation passed
  };

  const handleUpdateTemplate = async () => {
    const isFormValid = await validate();
    if (!isFormValid) return; // Only proceed if the form is valid
    try {
      setLoading(true);
      await updateTemplate();
      setIsLoading(true);
      setDialogOpen(true);
    } catch (error) {
      console.error(error, "error");
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    // handleCreateClose(); // Call the handleCreateClose function
    navigate(`/operations/templates${location.search}`); // Redirect to the specified route
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const widgetStructureOptions = widgetStructure.map((widget) => ({
    label: widget?.name, // Display name in the dropdown
    value: widget?.shared_uid, // Value to be used (shared_uid)
  }));

  const handleLabelsChange = (_: any, newValue: string[]) => {
    const newLabels = newValue
      ?.map((value) => value?.trim?.() || value)
      ?.filter((value) => value);
    const uniqueLabels = [...new Set(newLabels)];
    setSelectedLabels(uniqueLabels);
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={
            snackbarMessage.includes("Error") || isValid ? "success" : "error"
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };

  const formatJSON = () => {
    try {
      const parsedJSON = JSON.parse(additionalSettings.trim() || "{}");
      const formattedJSON = JSON.stringify(parsedJSON, null, 2);
      setAdditionalSettings(formattedJSON);
      setShowErrorMessage(false);
    } catch (error) {
      setShowErrorMessage(true);
    }
  };

  const handleFormatHTML = () => {
    if (html?.trim() !== "" && html?.length > 0) {
      const parser = new DOMParser();
      const document = parser.parseFromString(html, "text/html");
      const hasParserError = document.querySelector("parsererror") !== null;
      const hasElement = Array.from(document.body.childNodes).some(
        (node) => node.nodeType === Node.ELEMENT_NODE
      );
      if (!hasParserError && hasElement) {
        const formattedCode = beautifyHtml(html, {
          indent_size: 2,
          indent_char: " ",
          max_preserve_newlines: 2,
          preserve_newlines: true,
          end_with_newline: true,
          wrap_line_length: 0, // No line wrapping
          wrap_attributes: "auto", // "auto", "force", "force-aligned", "force-expand-multiline"
          wrap_attributes_indent_size: 4,
          indent_inner_html: true,
          indent_body_inner_html: true,
          indent_head_inner_html: true,
          unformatted: ["pre", "code", "textarea"], // Tags that shouldn't be formatted
          content_unformatted: ["pre", "textarea"], // Tags whose content shouldn't be formatted
          extra_liners: ["head", "body", "/html"], // Tags that get extra line breaks
        });
        setHtml(formattedCode);
        setErrorMessage(false);
      } else {
        setErrorMessage(true);
      }
    }
  };

  const handleFormatCSS = () => {
    if (css?.trim() !== "" && css?.length > 0) {
      const style = document.createElement("style");
      style.textContent = css;
      document.head.appendChild(style);
      const sheet = style.sheet as CSSStyleSheet;
      const valid = sheet && sheet.cssRules.length > 0;
      if (valid) {
        const formatted = beautifyCss(css, {
          indent_size: 2,
          indent_char: " ",
          selector_separator_newline: true,
          newline_between_rules: true,
          end_with_newline: true,
          preserve_newlines: false,
          max_preserve_newlines: 1,
          wrap_line_length: 0, // No line wrapping
          space_around_combinator: true,
        });
        setCss(formatted);
        setErrorMsg(false);
      } else {
        setErrorMsg(true);
      }
    }
  };

  useEffect(() => {
    if (singlePageContent) {
      setTemplateName(singlePageContent?.name);
      let value = singlePageContent?.additional_info; // Get the additional_info from singlePageContent
      value = value
        ?.replace(/\\n/g, "")
        ?.replace(/\\\\/g, "")
        ?.replace(/\\"/g, '"'); // Remove "\n", "\\" and extra backslashes
      if (value?.startsWith('"') && value?.endsWith('"')) {
        // Remove starting and ending quotes
        value = value?.slice(1, -1); // Remove the first and last character
      }
      setAdditionalSettings(value);
      try {
        const parsed = JSON.parse(value || "{}");
        setJsonObject(parsed);
      } catch (error) {
        setJsonObject({});
      }
    }
  }, [singlePageContent]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {renderSnackbar()}
          <Paper
            sx={{
              padding: "8px 16px",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography fontSize={24}>Edit Template</Typography>
            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                height: "706px",
                paddingRight: "16px",
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Stack>
                      <Typography marginTop={1}>General</Typography>
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Template Name"
                        multiline
                        required
                        color="secondary"
                        size="small"
                        maxRows={4}
                        value={templateName} // Bind to templateName state
                        onChange={(e) => setTemplateName(e.target.value)} // Update templateName on change
                        sx={{
                          width: "100%",
                          marginTop: "16px",
                        }}
                      />
                      <Typography fontSize={12} marginTop={0.5}>
                        minimum of 8 characters, only letters and numbers.{" "}
                      </Typography>
                      <Autocomplete
                        sx={{ width: "100%", marginTop: "16px" }}
                        options={siteOptions}
                        getOptionLabel={(option) => option.siteName}
                        value={
                          siteOptions?.find(
                            (option: any) => option?.uid === websiteSharedUid
                          ) || null
                        }
                        disabled
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="What Element does this template refers to"
                            label="Realated Website"
                            InputProps={{
                              ...params.InputProps,
                            }}
                            color="secondary"
                            required
                          />
                        )}
                        size="small"
                      />
                      <Autocomplete
                        sx={{ width: "100%", marginTop: "16px" }}
                        options={
                          widgetStructureOptions ? widgetStructureOptions : []
                        }
                        value={
                          widgetStructureOptions.find(
                            (option) => option.value === selectedWidgetStructure
                          ) || null
                        }
                        disabled
                        onChange={(_, newValue) => {
                          // Set the shared_uid of the selected widget
                          setSelectedWidgetStructure(
                            newValue ? newValue.value : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="What Element does this template refer to"
                            label="Component Type"
                            InputProps={{
                              ...params.InputProps,
                            }}
                            color="secondary"
                            required
                          />
                        )}
                        size="small"
                      />
                      <Typography marginBlock={2}>Labels</Typography>
                      <Autocomplete
                        multiple
                        filterSelectedOptions
                        freeSolo
                        id="fixed-tags-demo"
                        value={selectedLabels}
                        onChange={handleLabelsChange}
                        options={labels} // Assuming labels is an array of available options
                        getOptionLabel={(option) => option} // Assuming option is a string
                        renderTags={(tagValue, getTagProps) => (
                          <Box
                            sx={{
                              maxHeight: 180, // Limit height for about 8 chips
                              overflowY: "auto", // Enable scrolling when content overflows
                              display: "flex",
                              flexWrap: "wrap", // Ensure chips wrap to the next line if needed
                              gap: "12px", // Add space between each chip
                            }}
                          >
                            {tagValue.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({
                                index,
                              });
                              return (
                                <Chip
                                  key={key}
                                  label={option}
                                  {...tagProps}
                                  color="secondary"
                                  sx={{
                                    backgroundColor: "#7B1FA2",
                                    border: "1px solid #7B1FA2",
                                    color: "#FFFFFF",
                                    "& .MuiChip-deleteIcon": {
                                      color: "#D7BBE3", // Set the color of the delete icon (cross)
                                    },
                                  }}
                                />
                              );
                            })}
                          </Box>
                        )}
                        sx={{
                          width: "100%",
                          height: "234px",
                          "& .MuiAutocomplete-endAdornment": {
                            top: "9%", // Position the clear button at the top 9%
                            position: "absolute", // Ensure it's positioned relative to the container
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none", // This removes the popup indicator (dropdown arrow)
                          },
                        }}
                        size="small" // Set Autocomplete size to small
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Label"
                            placeholder="Add new label"
                            color="secondary"
                            sx={{
                              "& .MuiInputBase-root": {
                                minHeight: "234px", // Adjust the height of the textarea here
                                alignItems: "flex-start", // Align the input and placeholder to the top
                              },
                              "& .MuiFormLabel-root": {
                                top: "-5px", // Adjust label position closer to the top
                              },
                              "& .MuiInputBase-input": {
                                paddingTop: "8px", // Add padding to position text at the top
                              },
                            }}
                          />
                        )}
                      />

                      <Box sx={{ marginTop: "68px" }}>
                        <Typography marginBlock={2}>
                          Additional Settings
                        </Typography>
                        <Box
                          sx={{
                            flex: 1,
                            border: "1px solid #ddd",
                            borderRadius: 1,
                          }}
                        >
                          <AceEditor
                            ref={htmlEditorRef}
                            mode="json"
                            theme="dark"
                            name="json-dictionary-editor"
                            onChange={(value: any) =>
                              setAdditionalSettings(value)
                            }
                            value={additionalSettings}
                            fontSize={12}
                            showPrintMargin={false}
                            showGutter={false}
                            highlightActiveLine={true}
                            width="100%"
                            height="80px" // Set height to match SnackbarContent
                            setOptions={{
                              enableBasicAutocompletion: false,
                              enableLiveAutocompletion: false,
                              enableSnippets: true,
                              tabSize: 2,
                              useWorker: false,
                              wrap: true,
                              fontSize: 14,
                              fontFamily: "Geist Mono, monospace",
                              showLineNumbers: false,
                              // copyWithEmptySelection: true,
                            }}
                            editorProps={{
                              $blockScrolling: true,
                            }}
                            style={{
                              borderRadius: "4px",
                            }}
                          />
                          {additionalSettings && showErrorMessage === true ? (
                            <Typography
                              fontSize={12}
                              marginTop={2}
                              color={"#D32F2F"}
                            >
                              Invalid JSON format. Please correct the JSON
                              syntax.
                            </Typography>
                          ) : null}
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item xs={8}>
                    <Stack flexDirection={"row"} gap={4}>
                      <Grid item xs={6}>
                        <Stack>
                          <Typography marginTop={1} marginBottom={2}>
                            Code
                          </Typography>
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "-11px",
                                left: "8px",
                                padding: "2px 6px",
                                backgroundColor: "#fff",
                                fontSize: "12px",
                                borderRadius: "4px",
                                zIndex: 1,
                                color: htmlFocus
                                  ? "#9C27B0"
                                  : "rgba(0, 0, 0, 0.6)",

                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                                fontWeight: 400,
                                lineHeight: "1.4375em",
                                letterSpacing: "0.00938em",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              HTML
                            </div>
                            <Box
                              sx={{
                                height: "471px",
                                padding: "16.5px 14px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",

                                transition: "border-color 0.2s ease",

                                "&:hover": {
                                  borderColor: htmlFocus
                                    ? "#9C27B0"
                                    : "rgba(0, 0, 0, 0.87)",
                                },

                                ...(htmlFocus && {
                                  border: "1px solid #9C27B0",
                                }),
                              }}
                              onFocus={() => setHtmlFocus(true)}
                              onBlur={() => setHtmlFocus(false)}
                            >
                              <AceEditor
                                ref={htmlEditorRef}
                                mode="html"
                                theme="xcode"
                                name="html-dictionary-editor"
                                onChange={(value: any) => setHtml(value)}
                                value={html}
                                onFocus={() => setHtmlFocus(true)}
                                onBlur={() => setHtmlFocus(false)}
                                fontSize={12}
                                showPrintMargin={false}
                                showGutter={false}
                                highlightActiveLine={true}
                                width="100%"
                                height="450px"
                                setOptions={{
                                  enableBasicAutocompletion: false,
                                  enableLiveAutocompletion: false,
                                  enableSnippets: true,
                                  tabSize: 2,
                                  useWorker: false,
                                  wrap: true,
                                  fontSize: 14,
                                  fontFamily: "Geist Mono, monospace",
                                  showLineNumbers: false,
                                  copyWithEmptySelection: true,
                                }}
                                editorProps={{
                                  $blockScrolling: true,
                                }}
                                style={{
                                  borderRadius: "4px",
                                }}
                              />
                              {html && errorMessage === true ? (
                                <Typography
                                  fontSize={12}
                                  marginTop={2}
                                  color={"#D32F2F"}
                                >
                                  Invalid HTML format. Please correct the HTML
                                  syntax.
                                </Typography>
                              ) : null}
                            </Box>
                            <Button
                              variant="outlined"
                              endIcon={<FormatAlignCenterIcon />}
                              color="secondary"
                              size="small"
                              sx={{ mt: 5, alignSelf: "flex-start" }}
                              disabled={!html}
                              onClick={handleFormatHTML}
                            >
                              Format
                            </Button>
                          </div>
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack sx={{ marginTop: "48px" }}>
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "-11px",
                                left: "8px",
                                padding: "2px 6px",
                                backgroundColor: "#fff",
                                fontSize: "12px",
                                borderRadius: "4px",
                                zIndex: 1,
                                color: cssFocus
                                  ? "#9C27B0"
                                  : "rgba(0, 0, 0, 0.6)",

                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                                fontWeight: 400,
                                lineHeight: "1.4375em",
                                letterSpacing: "0.00938em",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              CSS
                            </div>
                            <Box
                              sx={{
                                height: "471px",
                                padding: "16.5px 14px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",

                                transition: "border-color 0.2s ease",

                                "&:hover": {
                                  borderColor: cssFocus
                                    ? "#9C27B0"
                                    : "rgba(0, 0, 0, 0.87)",
                                },

                                ...(cssFocus && {
                                  border: "1px solid #9C27B0",
                                }),
                              }}
                              onFocus={() => setCssFocus(true)}
                              onBlur={() => setCssFocus(false)}
                            >
                              <AceEditor
                                mode="css"
                                theme="xcode"
                                name="css-dictionary-editor"
                                onChange={(value: any) => setCss(value)}
                                value={css}
                                onFocus={() => setCssFocus(true)}
                                onBlur={() => setCssFocus(false)}
                                fontSize={12}
                                showPrintMargin={false}
                                showGutter={false}
                                highlightActiveLine={true}
                                width="100%"
                                height="450px"
                                setOptions={{
                                  enableBasicAutocompletion: false,
                                  enableLiveAutocompletion: false,
                                  enableSnippets: true,
                                  tabSize: 2,
                                  useWorker: false,
                                  wrap: true,
                                  fontSize: 14,
                                  fontFamily: "Geist Mono, monospace",
                                  showLineNumbers: false,
                                  copyWithEmptySelection: true,
                                }}
                                editorProps={{
                                  $blockScrolling: true,
                                }}
                                style={{
                                  borderRadius: "4px",
                                }}
                              />
                              {css && errorMsg === true ? (
                                <Typography
                                  fontSize={12}
                                  marginTop={2}
                                  color={"#D32F2F"}
                                >
                                  Invalid CSS format. Please correct the CSS
                                  syntax.
                                </Typography>
                              ) : null}
                            </Box>
                            <Button
                              variant="outlined"
                              color="secondary"
                              size="small"
                              endIcon={<FormatAlignCenterIcon />}
                              sx={{ mt: 5, alignSelf: "flex-start" }}
                              disabled={!css}
                              onClick={handleFormatCSS}
                            >
                              Format
                            </Button>
                          </div>
                          {/* <TextField
                            id="outlined-textarea"
                            label="CSS"
                            value={css}
                            onChange={(e) => {
                              setCss(e.target.value);
                            }}
                            placeholder="{}"
                            multiline
                            rows={19}
                            color="secondary"
                            sx={{ marginTop: "48px" }}
                          /> */}
                        </Stack>
                      </Grid>
                    </Stack>

                    <SnackbarContent
                      sx={{
                        background: "#FDEDED",
                        color: "#5F2120",
                        marginTop: "48px",
                        boxShadow: "none",
                        border: "1px solid #D32F2F80",
                        padding: "0 4px",
                      }}
                      message={
                        <Box display="flex">
                          <ErrorOutlineIcon
                            sx={{ marginRight: "8px", color: "#5F2120" }}
                          />
                          <Box>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              sx={{ marginBottom: "4px" }}
                            >
                              Update with Caution:
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2, // Limit the text to 2 lines
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis", // Adds ellipsis if text is too long
                              }}
                            >
                              Please proceed with extreme care when making
                              updates, as these changes may adversely affect the
                              overall design functionality. Ensure thorough
                              testing and validation to avoid any unintended
                              disruptions or errors in the end user experience.
                            </Typography>
                          </Box>
                        </Box>
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box>
              <Stack
                flexDirection={"row"}
                justifyContent={"space-between"}
                marginTop={2}
                gap={1}
              >
                {/* Left side: Format button */}
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  endIcon={<FormatAlignCenterIcon />}
                  disabled={!additionalSettings}
                  onClick={formatJSON}
                >
                  Format
                </Button>
                {/* Right side: Cancel and Save Changes buttons */}
                <Stack flexDirection={"row"} gap={1}>
                  <Button color="secondary" variant="outlined">
                    <Stack
                      flexDirection={"row"}
                      onClick={handleCancelClick}
                      gap={1}
                    >
                      <ArrowBackIosNewIcon fontSize="small" />
                      Cancel
                    </Stack>
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={
                      !templateName ||
                      !selectedWidgetStructure ||
                      !html ||
                      !css ||
                      errorMessage ||
                      showErrorMessage ||
                      errorMsg
                    }
                    data-tracker="153"
                    onClick={handleUpdateTemplate}
                    sx={{ textTransform: "uppercase" }}
                  >
                    <Stack flexDirection={"row"} gap={1}>
                      {loading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Save Changes"
                      )}
                      <CheckIcon fontSize="small" />
                    </Stack>
                  </Button>
                </Stack>
              </Stack>
            </Box>
          </Paper>
          <Dialog open={dialogOpen} maxWidth="md" fullWidth>
            <Paper sx={{ padding: "16px 24px 20px 24px" }}>
              <DialogContent>
                <Typography variant="h6">
                  Changes Saved Successfully!
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  color="secondary" //test
                  variant="contained"
                  onClick={handleClose}
                  sx={{ textTransform: "uppercase" }}
                >
                  Close
                </Button>
              </DialogActions>
            </Paper>
          </Dialog>
        </>
      )}
    </>
  );
};

export default EditTemplate;
